import React from "react";
function MiniStatistics(props: {
  name: string;
  values?: string;
  icon: JSX.Element;
  value: string;
  iconBg: string;
}) {
  const { name, value, icon, iconBg } = props;
  return (
    <div className="flex w-full items-center gap-3 rounded-xl bg-white border border-leadrs-stroke px-[18px] py-4 shadow-sm">
      <div
        className={`flex h-[56px] w-14 items-center justify-center rounded-full text-[28px] ${iconBg}`}
      >
        {icon}
      </div>
      <div>
        <p className="mb-1 text-sm font-medium font-geist text-leadrs-text-soft">{name}</p>
        <h3 className="text-xl font-bold leading-6 font-geist text-leadrs-text">
          {value}
        </h3>
      </div>
    </div>
  );
}

export default MiniStatistics;
